// extracted by mini-css-extract-plugin
var _1 = "Y3B8zJDnJe1duKqOeRLB";
export { _1 as "questionStyle" }
